import React from 'react';
import { useState } from 'react';
import { TableHead } from '@material-ui/core';
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import AccountStatus from './accountStatus';
import MaterialTable from 'material-table';
import { accountsSyncStatusTableOption } from '../../helper/constants';

const SystemStatus = (props) => {

    const system = props.system;

    const [showAccounts, setShowAccounts] = useState(false);
    const [shouldRotateArrow, setShouldRotateArrow] = useState(false);

    const clickHandler = () => {
        setShowAccounts(!showAccounts);
        setShouldRotateArrow(!shouldRotateArrow);
    };

    const renderAccounts = () => showAccounts ?
        <>
            <MaterialTable
                data={[system]}
                options={accountsSyncStatusTableOption}
                components={{
                    Header: () => {
                        return <TableHead className='view-info-label' onClick={() => clickHandler()}>
                            <TableRow>
                                <TableCell width="150rem">
                                    <label className='table-cell-status-item'>Accounts</label>
                                </TableCell>
                                <TableCell width="15rem">
                                    <label className='table-cell-status-item'>Last Update Date</label>
                                </TableCell>
                                <TableCell width="15rem">
                                    <label className='table-cell-status-item'> Sync Status</label>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                    }
                }}>
            </MaterialTable>
            {system.accounts.map(acc => <AccountStatus key={acc.id} acc={acc} />)}
        </> : <></>;

    return (
        <div>
            <MaterialTable
                data={[system]}
                options={accountsSyncStatusTableOption}
                components={{
                    Header: () => {
                        return <TableHead className='view-info-label' onClick={() => clickHandler()}>
                            <TableRow>
                                <TableCell align='left' width="5rem">
                                    <i className={`fa fa-arrow-right ${shouldRotateArrow ? "rotate" : ""}`} />
                                </TableCell>
                                <TableCell align='left' className='table-cell-status-container' width="150rem">
                                    {system.name}
                                </TableCell>
                                <TableCell align='left' className='table-cell-status-container' width="15rem">
                                    {system.isHealthy ? <i className="fas fa-check circle-color-healthy" /> : <i className='fas fa-minus circle-color-unhealthy' />}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                    }
                }}>
            </MaterialTable>
            {renderAccounts()}
        </div>
    );
};

export default SystemStatus;